import { render } from "./AppHeader.vue?vue&type=template&id=46612820"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=46612820&lang=css"

import exportComponent from "/home/innovation/Documents/project/for small pos/akezaStore/clientnew/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__